module.exports = __webpack_public_path__ + "img/team-09.87cb70ea.jpg";